export enum DashboardFiltersType {
  facilities = 'facilities',
  auditors = 'auditors',
  auditTypes = 'auditTypes',
  datesRange = 'datesRange'
}
